import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { isEmpty, split } from 'lodash';
import { map } from 'rxjs';

import { SharedAuthFacade } from '../+state/auth.facade';
import { AUTH_CONFIG, DEFAULT_AUTH_CONFIG } from '../auth-config';
import { AuthService } from '../services/auth.service';

export const authGuardFn: CanActivateChildFn = (_childRoute, state) => {
  const authService = inject(AuthService);
  const { redirectUrl } = inject(AUTH_CONFIG) || DEFAULT_AUTH_CONFIG;
  const router = inject(Router);

  const redirectPath = Array.isArray(redirectUrl)
    ? split(redirectUrl, '/')
    : ['/sign-in'];
  authService.callingUrl = state.url;

  return !isEmpty(authService.checkSessionValid())
    ? true
    : router.createUrlTree(redirectPath);
};

export const twoFactorAuthGuardFn: CanActivateFn = () => {
  const authFacade = inject(SharedAuthFacade);
  const router = inject(Router);
  return authFacade.requiresMfa$.pipe(
    map((requiresMfa) => {
      if (!requiresMfa) router.navigate(['/sign-in']);
      return requiresMfa;
    })
  );
};

export const unAuthGuardFn: CanActivateFn = () => {
  const authFacade = inject(SharedAuthFacade);
  const router = inject(Router);

  return authFacade.isAuthenticated$.pipe(
    map((isAuthenticated) => {
      return !isAuthenticated ? true : router.createUrlTree(['/']);
    })
  );
};
